import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { usePersistedPrompts } from "@/hooks";
import { cn } from "@/lib/utils";
import { useQueuedPromptsStore } from "@/state/stores";
import { ChevronDown, X } from "lucide-react";
import { useState } from "react";

export function QueuedPrompts() {
  const prompts = useQueuedPromptsStore((state) => state.prompts);
  const { removeFromPromptQueue } = usePersistedPrompts();
  const [isOpen, setIsOpen] = useState(true);

  if (!prompts.length) {
    return null;
  }

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className="grid gap-2 border border-b-0 px-3 pt-2 rounded-t-xl pb-4 -mb-5 bg-background/50 animate-slide-up"
    >
      <div className="grid grid-cols-[1fr_auto] gap-2">
        <h3 className="text-xs text-muted-foreground flex items-center gap-2">
          Queued Prompts
          {!isOpen && (
            <span className="text-foreground text-xs font-mono bg-accent px-2 rounded-full">
              {prompts.length}
            </span>
          )}
        </h3>

        <CollapsibleTrigger asChild>
          <Button
            type="button"
            variant="default"
            size="icon-xs"
            className="h-6 w-6 -mr-2 -mt-1 rounded-full"
          >
            <ChevronDown
              className={cn("transition-transform", !isOpen && "rotate-180")}
            />
          </Button>
        </CollapsibleTrigger>
      </div>

      <CollapsibleContent>
        <ul className="flex flex-col gap-2 mb-2">
          {prompts.map((prompt) => (
            <li
              key={prompt.id}
              className="text-xs grid grid-cols-[1fr_auto] gap-1 hover:bg-muted rounded-sm pl-2 pr-1 py-1 -mx-2 -my-1"
            >
              <span className="truncate">{prompt.message}</span>
              <Button
                size="icon-xs"
                variant="ghost"
                className="h-4 w-4"
                onClick={() => removeFromPromptQueue(prompt.id)}
              >
                <X className="h-3 w-3" />
              </Button>
            </li>
          ))}
        </ul>
      </CollapsibleContent>
    </Collapsible>
  );
}
